<template>
  <app-loading :loading="loading" class="content" v-if="fertilizer.id">
    <headBar :title="fertilizer.name" :isUser="isUser" class="indent"/>
    <general class="indentBlock" v-if="fertilizer.general" :data="fertilizer.general"/>
    <price class="indentBlock" v-if="fertilizer" :data="fertilizer" />
    <solubility class="indentBlock" v-if="fertilizer.solubility" :data="fertilizer.solubility"/>
    <nutrient class="indentBlock" v-if="fertilizer.macro" :data="fertilizer.macro"/>
    <microelement class="indentBlock" v-if="fertilizer.micro" :data="fertilizer.micro"/>
  </app-loading>
</template>

<script>
import HeadBar from '@/components/fertilizers/content/Head'
import General from '@/components/fertilizers/content/General'
import Price from '@/components/fertilizers/content/Price'
import Solubility from '@/components/fertilizers/content/Solubility'
import Nutrient from '@/components/fertilizers/content/Nutrient'
import Microelement from '@/components/fertilizers/content/Microelement'
import { mapGetters } from 'vuex';


export default {
  components: {
    HeadBar,
    Solubility,
    General,
    Nutrient,
    Price,
    Microelement
  },
  computed: {
    ...mapGetters({
      loading: 'fertilizers/loading',
      fertilizer: 'fertilizers/getFertilizer',
      isUser: 'fertilizers/isUser',
    })
  }
}
</script>

<style lang="scss" scoped>
  .content {
    padding-top: 20px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .indent {
      margin-left: 8px;
      margin-right: 8px;

      &Block {
        width: 100%;
        margin-bottom: 8px;
        margin-left: 8px;
        margin-right: 8px;

        @media (max-width: 768px) {
          margin-left: 0;
          margin-right: 0;
        }
      }
    }
  }
</style>
